import Vue from 'vue';

const success = (context, response, notRemoveLoading) => {
  context.user = response.user;
  context.countries = response.countries;
  if (response.user.setting == null) {
    context.user.setting = {};
  }
  if (!context.user.country_id) {
    context.user.country_id = 1;
  }
  if (!context.dontRemoveLoading && !notRemoveLoading) {
    context.loading = false;
  }
};

const failed = (context, error) => {

};

export default (context, notRemoveLoading = false) => Vue.$http.get('/account').then((response) => {
  if (response && response.status === 200) {
    success(context, response.data, notRemoveLoading);
  } else {
    failed(context, response);
  }
}).catch(((error) => {
  failed(context, error);
}));



// WEBPACK FOOTER //
// ./src/app/services/account/fetchUserAccount.js